
import { React } from "react";
import { Box, Typography } from "@mui/material";
import CategoryGroup from "./CategoryGroup";
import { useTranslation } from "react-i18next";

export default function CategoriesList({
	categories,
	transactions,
	selectedType,
	setSelectedType,
	selectedCategory,
	setSelectedCategory,
	selectedSubcategory,
	setSelectedSubcategory,
}) {
	const { t } = useTranslation();
	const getCategoriesForType = (type) => {
		const categoriesForType = categories.filter(
			(category) => category.type === type
		);
		return categoriesForType;
	};

	const getTransactionsForType = (type) => {
		const transactionsForCategoryGroup = transactions.filter(
			(transaction) => transaction.type === type
		);
		return transactionsForCategoryGroup;
	};

	return (
		<Box
			sx={{
				display: "flex",
				flexDirection: "column",
				pt: 2,
				pl: 2,
				pb: 1,
				width: "100%",
			}}
		>
			<Box sx={{ ml: 1, mb: 2 }}>
				<Typography variant="h6" id="tableTitle" component="div">
					{t("categories")}
				</Typography>
			</Box>
			<Box
				sx={{
					display: "flex",
					flexWrap: "wrap",
					flexDirection: "row",
					width: "100%",
				}}
			>
				{getTransactionsForType("expense").length === 0 &&
					getCategoriesForType("income").length === 0 && (
						<Box sx={{ mx: 1, mb: 2, fontSize: 15 }}>
							{t("noTransactionsFound")}
						</Box>
					)}
				{getTransactionsForType("expense").length > 0 && (
					<CategoryGroup
						categoriesType={"expense"}
						data={getCategoriesForType("expense")}
						transactions={getTransactionsForType("expense")}
						selectedType={selectedType}
						setSelectedType={setSelectedType}
						selectedCategory={selectedCategory}
						setSelectedCategory={setSelectedCategory}
						selectedSubcategory={selectedSubcategory}
						setSelectedSubcategory={setSelectedSubcategory}
					/>
				)}
				{getCategoriesForType("income").length > 0 && (
					<CategoryGroup
						categoriesType={"income"}
						data={getCategoriesForType("income")}
						transactions={getTransactionsForType("income")}
						selectedType={selectedType}
						setSelectedType={setSelectedType}
						selectedCategory={selectedCategory}
						setSelectedCategory={setSelectedCategory}
						selectedSubcategory={selectedSubcategory}
						setSelectedSubcategory={setSelectedSubcategory}
					/>
				)}
			</Box>
		</Box>
	);
}
